/**
 * Created by zad on 17/1/12.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Animate from 'rc-animate';
import Loader from '../Loading/Loader';
import styles from './NestLoading.scss';

const loadingPrefix = 'loading';

export default class Loading extends Component {
  static propTypes = {
    size: PropTypes.oneOf(['small', 'default', 'large']),
    loading: PropTypes.bool,
    tip: PropTypes.string,
    delay: PropTypes.number,
    hasMask: PropTypes.bool,
    wrapperClassName: PropTypes.string,
  };

  static defaultProps = {
    loading: true,
    delay: undefined,
    hasMask: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: this.props.loading,
    };
    this.debounceLoading = this.debounceLoading.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.debounceLoading(nextProps);
  }

  componentWillUnmount() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
  }

  // 对改变loading状态进行去抖
  debounceLoading(nextProps) {
    const prevLoading = this.props.loading;
    const nextLoading = nextProps.loading;
    const { delay } = this.props;

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    // 如果设定了delay且前后状态不一致
    if (delay && !Number.isNaN(+delay) && prevLoading !== nextLoading) {
      this.debounceTimer = setTimeout(() => this.setState({ loading: nextLoading }), delay);
    } else {
      this.setState({ loading: nextLoading });
    }
  }

  render() {
    const { size, hasMask, tip, wrapperClassName } = this.props;
    const { loading } = this.state;

    const wrapperClass = classNames(
      wrapperClassName,
      styles['loading-panel'],
      {
        [styles['loading-panel__none']]: !loading,
        [styles['loading-panel-has-mask']]: hasMask,
      },
    );
    // const skClasses = classNames(styles['sk-circle'], {
    //   [styles['sk-circle-small']]: size === 'small',
    //   [styles['sk-circle-large']]: size === 'large',
    // });

    return (
      <Animate
        className={wrapperClass}
        transitionName='fade'
        component="div"
      >
        <Loader key='bb' size={size} tip={tip} loading={loading} loaderClassName={styles['center']}/>
      </Animate>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading/NestLoading.js